<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-1 text-weight-bold titulo-base">
        Inventário
      </p>
    </div>

    <div style="max-width: 370px" class="column col-2 q-ml-lg">
      <span style="font-weight: bold" class="q-mb-sm text-brand-1"
        >Unidade</span
      >

      <lista-unidades-select v-model="unidade" />
    </div>

    <section class="row botoes-base q-ml-sm">
      <span>
        <q-btn
          class="q-ml-sm btn"
          @click="novo"
          :disable="$store.state.org.unidadeData.id"
          color="brand-1"
          label="Criar Inventário"
          no-caps
          icon="add"
        />
      </span>
      <span>
        <q-btn
          class="q-ml-md btn"
          color="brand-2"
          no-caps
          @click="upload"
          label="Criar em massa"
          icon="add"
        />
      </span>

      <span>
        <q-btn
          class="q-ml-md btn"
          color="brand-1"
          no-caps
          @click="confirmacao = true"
          :disable="isInProcess"
          label="Sincronizar Estoque"
          v-if="
            $store.state.autenticacao.cliente.includes('cerradinho') ||
            $store.state.autenticacao.cliente.includes('staging-cerradinho')
          "
          icon="refresh"
        />
      </span>
      <span>
        <q-btn
          class="q-ml-md btn"
          color="brand-1"
          no-caps
          @click="sincronizarEstoqueClealco"
          label="Sincronizar Estoque"
          v-if="
            $store.state.autenticacao.cliente.includes('clealco') ||
            $store.state.autenticacao.cliente.includes('staging-clealco')
          "
          icon="refresh"
        />
      </span>
      <span>
        <q-btn
          class="q-ml-md btn"
          color="brand-1"
          no-caps
          @click="sincronizarEstoqueClealco"
          label="Sincronizar Estoque"
          v-if="
            $store.state.autenticacao.cliente.includes('libbs') ||
            $store.state.autenticacao.cliente.includes('staging-libbs')
          "
          icon="refresh"
        />
      </span>
    </section>

    <div class="q-pt-md q-mt-lg">
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        title="Meus Inventários em aberto"
        :rows="rows"
        :columns="columns"
        class="tabela-tamanho-fixo"
        dense
        :loading="disable"
        :filter="filtrar"
        hide-pagination
        v-model:pagination="pagination"
        :rows-per-page-options="[0]"
        @request="handleRequest"
      >
        <template v-slot:top-right>
          <div class="row">
            <span
              ><q-input
                rounded
                outlined
                dense
                debounce="300"
                v-model="filtrar"
                placeholder="Filtrar por nome"
              >
                <template v-slot:append>
                  <q-icon name="search" />
                </template> </q-input
            ></span>
          </div>
        </template>
        <template #body-cell-delete="props">
          <q-td>
            <span>
              <q-btn
                @click="editar(props.row.id)"
                color="positive"
                round
                icon="edit"
              />
            </span>
            <span>
              <q-btn
                class="q-ml-sm"
                @click="receberDadosInventarioExcluir(props.row)"
                color="negative"
                round
                icon="delete"
              />
            </span>
          </q-td>
        </template>
        <template #body-cell-created_at="props">
          <q-td>
            <span>{{
              props.row.created_at.split(" ")[0].split("-").reverse().join("/")
            }}</span>
            <span class="q-ml-sm">{{
              props.row.created_at.split(" ")[1]
            }}</span>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
    <q-dialog v-model="confirm" persistent>
      <q-card class="q-pa-sm text-brand-5 text-weight-bolder">
        <q-card-section class="row items-center">
          <span class="q-ml-sm"
            >Você tem certeza que deseja remover esse inventário?</span
          >
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            icon="cancel"
            no-caps
            dense
            outline
            label="Não"
            color="negative"
            v-close-popup
          />
          <q-btn
            no-caps
            dense
            outline
            label="Sim"
            color="positive"
            v-close-popup
            icon="check_circle_outline"
            @click="deleteId()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <dialog-confirm-design
      mensagem="A sincronização de estoque pode demorar, aguarde 10 minutos para sincronizar novamente."
      :titulo="'Deseja iniciar a sincronização?'"
      :exibir="confirmacao"
      @resultado="sincronizarEstoqueCerradinho"
    />
  </q-page>
</template>

<script>
const columns = [
  {
    name: "numero",
    label: "ID",
    field: "numero",
    align: "left",
  },
  {
    name: "name",
    label: "Requisitante",
    field: (row) =>
      row.funcionarios.length != 0
        ? row.funcionarios[0].name
        : "Sem Requisitante",
    align: "left",
  },
  {
    name: "numero",
    label: "Unidade",
    field: (row) => row.unidade.name,
    align: "left",
  },
  {
    name: "numero",
    label: "Num Produtos",
    field: (row) => row.produtos.length,
    align: "left",
  },
  {
    name: "created_at",
    label: "Criada em",
    field: "created_at",
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    field: "status",
    align: "left",
  },
  {
    name: "delete",
    label: "Ações",
    field: "delete",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useQuasar } from "quasar";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import DialogConfirmDesign from "../../../../components/DialogConfirmDesign.vue";
export default {
  components: { ListaUnidadesSelect, DialogConfirmDesign },
  setup() {
    const store = useStore();
    const router = useRouter();
    const $q = useQuasar();
    const confirmacao = ref(false);
    const rows = ref([]);
    const disable = ref(true);
    const filtrar = ref("");
    const unidade = ref();
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 50,
      rowsNumber: 15,
    });
    const inventarioExcluir = ref({
      id: "",
      status: "",
    });
    let confirm = ref(false);
    const timerKey = "integrationProductsTimeEnd";
    const isInProcess = ref(false);
    const getDados = async (page = 1, rowsPerPage = 50) => {
      $q.loading.show();
      try {
        const response = await store.dispatch("inventario/listarInventario", {
          vendor_id: store.state.org.unidadeData.id,
          page,
          per_page: rowsPerPage,
          numero: filtrar.value,
        });

        rows.value = response.data.result.data;
        pagination.value.rowsPerPage = response.data.result.per_page;
        pagination.value.rowsNumber = response.data.result.total;
        pagination.value.page = response.data.result.current_page;
        disable.value = false;
        $q.loading.hide();
      } catch (error) {
        $q.loading.hide();
        $q.notify({
          message: "Erro a o criar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const deleteId = async () => {
      if (
        inventarioExcluir.value.status != "Rascunho" &&
        inventarioExcluir.value.status != "Pendente"
      ) {
        $q.notify({
          message:
            "So podem ser deletados os inventarios com status Rascunho ou Pendente.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      try {
        await store.dispatch("inventario/excluirInventario", {
          inventory_id: inventarioExcluir.value.id,
          action: "cancelar",
        });

        $q.notify({
          message: "Deletado com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
      } catch (error) {
        $q.notify({
          message: "Erro a o deletar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const upload = async () => {
      router.push({ name: "inventario-upload" });
    };

    const editar = async (id) => {
      router.push({
        name: "inventario-novo",
        params: { id: id },
      });
    };

    const novo = async () => {
      try {
        const response = await store.dispatch("inventario/criarInventario", {
          vendor_id: store.state.org.unidadeData.id,
        });

        $q.notify({
          message: "Inventario criado com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        router.push({
          name: "inventario-novo",
          params: { id: response.data.result.uuid },
        });
      } catch (error) {
        $q.notify({
          message: "Erro a o criar inventario selecione uma unidade",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const receberDadosInventarioExcluir = (dados) => {
      inventarioExcluir.value = {
        id: dados.id,
        status: dados.status,
      };
      confirm.value = true;
    };

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const sincronizarEstoqueCerradinho = async (resultado) => {
      confirmacao.value = false;
      if (resultado) {
        const endTime = Date.now() + 10 * 60 * 1000; // 10 minutos a partir de agora
        localStorage.setItem(timerKey, endTime);
        try {
          await store.dispatch("inventario/sincronizarInventarioCerradinho");

          $q.notify({
            message: "Sincronizado com sucesso!",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          isInProcess.value = true;
        } catch (error) {
          $q.notify({
            message: "Erro a o sincronizar",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const getTimerIntegracao = async () => {
      const endTime = localStorage.getItem(timerKey);
      const remainingTime = endTime - Date.now();

      if (remainingTime <= 0) {
        localStorage.removeItem(timerKey);
        isInProcess.value = false;
      } else {
        isInProcess.value = true;
      }
    };

    const sincronizarEstoqueClealco = async () => {
      try {
        await store.dispatch("inventario/sincronizarInventarioClealco");

        $q.notify({
          message: "Sincronizado com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro a o sincronizar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => filtrar.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getDados();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);
    onMounted(getTimerIntegracao);

    return {
      pagination,
      rows,
      disable,
      columns,
      filtrar,
      getDados,
      deleteId,
      handleRequest,
      upload,
      novo,
      inventarioExcluir,
      receberDadosInventarioExcluir,
      sincronizarEstoqueCerradinho,
      sincronizarEstoqueClealco,
      editar,
      unidade,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      confirm,
      getTimerIntegracao,
      isInProcess,
      confirmacao,
    };
  },
};
</script>

<style scoped>
.titulo-base {
  font-size: 20px;
  font-weight: bold;
}

.botoes-base {
  margin-top: 55px;
}

.botoes-base button {
  border-radius: 8px;
  width: 210px;
}

.tableBackGround {
  background-color: #d9effc;
}
</style>
